import { render, staticRenderFns } from "./AppNavigationHeaderTodayButton.vue?vue&type=template&id=a0dcdc70&"
import script from "./AppNavigationHeaderTodayButton.vue?vue&type=script&lang=js&"
export * from "./AppNavigationHeaderTodayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0dcdc70')) {
      api.createRecord('a0dcdc70', component.options)
    } else {
      api.reload('a0dcdc70', component.options)
    }
    module.hot.accept("./AppNavigationHeaderTodayButton.vue?vue&type=template&id=a0dcdc70&", function () {
      api.rerender('a0dcdc70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/AppNavigationHeader/AppNavigationHeaderTodayButton.vue"
export default component.exports